import { render, staticRenderFns } from "./company.vue?vue&type=template&id=f145cea8&scoped=true"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"
import style0 from "./company.vue?vue&type=style&index=0&id=f145cea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f145cea8",
  null
  
)

export default component.exports